export default __webpack_public_path__ + "static/media/21.4a8f1cf3.png";